import { render, staticRenderFns } from "./AutoTriggerSql.vue?vue&type=template&id=50cb0c4e&scoped=true&"
import script from "./AutoTriggerSql.vue?vue&type=script&lang=js&"
export * from "./AutoTriggerSql.vue?vue&type=script&lang=js&"
import style0 from "./AutoTriggerSql.vue?vue&type=style&index=0&id=50cb0c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb0c4e",
  null
  
)

component.options.__file = "AutoTriggerSql.vue"
export default component.exports